import { useEffect, useRef } from 'react'
import { useLDClient } from 'launchdarkly-react-client-sdk'

import { getStorageKey } from '~/src/hooks/useTrackLdExposure/helper'

import { MixpanelEvent, track } from '~/clients/mixpanelClient'

type Options = {
  experimentName: string
  userId?: number
}

const useTrackLdExposure = ({ experimentName, userId }: Options) => {
  const hasTrackedRef = useRef(false)
  const ldClient = useLDClient()

  const detail = ldClient?.variationDetail(experimentName, true)

  useEffect(() => {
    const variation = detail?.value
    const isExperimentEnabled = detail?.reason?.inExperiment

    if (typeof window === 'undefined') return
    if (!isExperimentEnabled) return
    if (hasTrackedRef.current) return
    if (variation === undefined) return

    const variantName = String(variation)

    const storageKey = getStorageKey({
      userId,
      experimentName,
      variant: variation,
      isExperimentEnabled: isExperimentEnabled,
    })

    if (window.localStorage.getItem(storageKey)) {
      hasTrackedRef.current = true

      return
    }

    window.localStorage.setItem(storageKey, 'true')

    track(MixpanelEvent.ExperimentStarted, {
      'Experiment name': experimentName,
      'Variant name': variantName,
    })

    hasTrackedRef.current = true
  }, [detail, experimentName, userId])
}

export default useTrackLdExposure
